module.exports = __webpack_public_path__ + "static/img/4555.b88424cb.png";